import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as yup from "yup";

import { AuthContext } from "../../../providers/AuthProvider";
import starBackground from "../../../assets/Frame 427320198.svg";
import icon1 from "../../../assets/Captura de Tela 2024-06-18 às 19.42.20 1.png";
import icon2 from "../../../assets/iconLogin1.png";
import logo from "../../../assets/ecomlovers-logo-transparente.svg";
import logoAstro from "../../../assets/image 11.png";
import iconHeart from "../../../assets/Vector (23).png";
import api from "../../../utils/api";

import "./LoginWeb.css";

const LoginWeb = () => {
  const navigate = useNavigate();
  const [isPhone, setIsPhone] = useState(true)

  function isMobileDevice() {
    return window.innerWidth <= 800;
  }

  return (
    <div className="backgroundWeb">
      <div className="containerScale">

        <div className="boxContentUserTypeSelectorWeb">

          <div className="contentContainerWeb" style={{}}>
            <div
              className="backGrounDividWeb"
            >
              <img
                src={logo}
                alt="logo"
                className="logoWeb"
              />

              <div className="lineLOgin" />
            </div>
            <div style={{ flex: 1 }}></div>

            <div className="boxUserTypeSelectorContainer">
              <img
                src={icon1}
                alt="icon"
                className="imageLOgin"
              />

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <div className="title">Bem-vindo à eComLovers!</div>

                <div
                  className="containerUserTypeSelectorWeb"
                  style={{ marginTop: "10px", marginBottom: "50px", gap: "10px" }}
                >
                  <div
                    className="buttonLoginTalent"
                    onClick={() => { navigate("/talents") }}
                  >
                    Sou um talento
                  </div>
                  <div
                    className="buttonLoginCompany"
                    onClick={() => { navigate("/companies")}}
                  >
                    Sou uma empresa
                  </div>
                </div>
              </div>
            </div>

            <div className="footerLoginWeb">
              Desenvolvido com
              <img src={iconHeart} alt="" />
              <strong>© eComLovers®</strong>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default LoginWeb;
